export type IdentificationComponentValue = {
    idType: string,
    idNumber: string
} | null;

export type IdTypes = {value: string, label: string};
